import { ThisConnector } from '../../../../../api/connector'
import { BugtrackerRequest } from '../shared'
import { buildApiPayloadBugtrackerCredentials } from '../build-api-payload-bugtracker-credentials'

export interface GetTestBugtrackerArgs {
  organizationUuid: string
  bugtracker: 'jira' | 'vsts' | 'github' | 'agilecentral'
  bugtrackerRequest: BugtrackerRequest | null
}

export interface GetTestBugtrackerResponse {
  messages: string[]
  success: boolean
}

export async function getTestBugtracker(
  this: ThisConnector,
  { bugtrackerRequest, organizationUuid, bugtracker }: GetTestBugtrackerArgs
) {
  const { success, messages } =
    await this.connector.post<GetTestBugtrackerResponse>(
      `/${organizationUuid}/bugtrackers/${bugtracker}/test?expand=skip_links`,
      buildApiPayloadBugtrackerCredentials(bugtrackerRequest)
    )
  return { success, messages }
}
